import React from 'react';
import { HeaderPanel } from '../../HeaderPanel';
import { headerPanelOptions } from './panelSettings';
import { TagsEditor, TagsEditorProps } from 'components/TagsEditor/TagsEditor';
import './Tags.less';

export function TagsPanel({
  objectId,
  objectShortType,
  objectType,
}: TagsEditorProps) {
  const option :TagsEditorProps = {
    objectId,
    objectShortType,
    objectType,
  }

  return (
    <HeaderPanel {...headerPanelOptions('secondary', 'Tags')}>
      <div className="dpc-tags-panel">
        <TagsEditor {...option} />
      </div>
    </HeaderPanel>
  );
}
